import type { CancelAutoRenewConfirmDialogProps } from 'reactApp/components/CancelAutoRenewConfirmDialog/CancelAutoRenewConfirmDialog';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCancelAutoRenewConfirmDialog = ({ onClose, ...data }: CancelAutoRenewConfirmDialogProps) =>
    openPopupHelper({ popupName: popupNames.CANCEL_AUTO_RENEW_CONFIRM_DIALOG, data, onClose });

export const closeCancelAutoRenewConfirmDialog = () => closePopupHelper(popupNames.CANCEL_AUTO_RENEW_CONFIRM_DIALOG);
